import { useMutation, useQueryClient } from '@tanstack/react-query';

interface UpdateTagParams {
  id: number;
  name: string;
  description?: string;
  color_hex: string;
}

/**
 * 求職者タグを更新するフック
 */
export default function useUpdateCandidateTag() {
  const queryClient = useQueryClient();
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;

  return useMutation({
    mutationFn: async (params: UpdateTagParams) => {
      const { id, ...updateData } = params;
      const response = await fetch(`/agent/api/custom_tags/${id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          custom_tag: updateData,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to update tag');
      }

      return response.json();
    },
    onSuccess: () => {
      // タグ一覧を再取得
      queryClient.invalidateQueries({
        queryKey: ['/agent/api/candidate_profile_tags'],
      });
    },
  });
}
